import React from "react";
import { CustomCheckboxContainer, CustomCheckboxInput, } from "@reach/checkbox";
import "@reach/checkbox/styles.css";
import { createUseStyles } from "react-jss";
import DisplayText, { TextVariant } from "./DisplayText";
import clsx from "clsx";
var useStyles = createUseStyles(function (theme) { return ({
    label: {
        width: "100%",
        display: "inline-flex",
        "&.reverse": {
            flexDirection: "row-reverse",
            justifyContent: "space-between",
        },
        alignItems: "center",
        cursor: "pointer",
    },
    switch: {
        display: "inline-flex",
        width: 58,
        height: 38,
        padding: 12,
        position: "relative",
        boxSizing: "border-box",
        flexShrink: 0,
        verticalAlign: "middle",
        zIndex: 0
    },
    switchContainer: {
        top: 0,
        left: 0,
        width: 40,
        height: 40,
        zIndex: 1,
        position: "absolute",
        boxSizing: "border-box",
        padding: 9,
        color: "white",
        transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        "&:hover $outline": {
            opacity: 0.2,
            "&.checked": {
                backgroundColor: theme.color.primary.main
            }
        },
        "&:focus-within, &:focus": {
            outline: 0,
            boxShadow: "none",
        },
        "&.checked": {
            transform: "translateX(20px)",
            color: theme.color.primary.main
        }
    },
    inputContainer: {
        width: "100%",
        display: "flex",
    },
    thumb: {
        width: 20,
        height: 20,
        backgroundColor: "white",
        borderRadius: "50%",
        border: "1px solid ".concat(theme.color.primary.main),
        boxSizing: "inherit",
        boxShadow: "0px 2px 2px #00000029",
        transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        "&.checked": {
            backgroundColor: theme.color.primary.main,
        }
    },
    track: {
        width: "100%",
        height: "100%",
        zIndex: -1,
        borderRadius: 7,
        opacity: .3,
        backgroundColor: theme.color.primary.main,
        transition: "opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        "&.checked": {
            opacity: .5,
        },
        "&.disabled": {
            backgroundColor: "black",
        }
    },
    outline: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        overflow: "hidden",
        position: "absolute",
        borderRadius: "50%",
        pointerEvents: "none",
        boxSizing: "inherit",
        backgroundColor: "gray",
        opacity: 0,
        transition: "opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        "&.focused": {
            opacity: 0.2,
            "&.checked": {
                backgroundColor: theme.color.primary.main
            }
        }
    }
}); });
var Switch = function (props) {
    var _a, _b, _c, _d, _e;
    var classes = useStyles();
    var checked = (_a = props.value) !== null && _a !== void 0 ? _a : false;
    var labelColor = (_b = props.labelColor) !== null && _b !== void 0 ? _b : "primary";
    var limit = (_c = props.limitScaling) !== null && _c !== void 0 ? _c : false;
    return (React.createElement("div", { className: props.className },
        React.createElement("label", { className: clsx(classes.label, props.reverse && "reverse") },
            React.createElement("span", { className: classes.switch },
                React.createElement(CustomCheckboxContainer, { className: clsx(classes.switchContainer, checked && "checked"), checked: checked, onChange: props.onChange }, function (_a) {
                    var checked = _a.checked, focused = _a.focused;
                    return (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: classes.inputContainer },
                            React.createElement(CustomCheckboxInput, { name: props.name }),
                            React.createElement("span", { className: clsx(classes.thumb, checked && "checked") })),
                        React.createElement("span", { className: clsx(classes.outline, focused && "focused", checked && "checked") })));
                }),
                React.createElement("span", { className: clsx(classes.track, checked && "checked") })),
            React.createElement(DisplayText, { variant: (_d = props.labelVariant) !== null && _d !== void 0 ? _d : TextVariant.s18reg, component: "span", color: labelColor, limitScaling: limit }, props.labelText)),
        props.helperText &&
            React.createElement(DisplayText, { className: classes.helperText, variant: TextVariant.s12reg, color: (_e = props.helperColor) !== null && _e !== void 0 ? _e : "#818181", limitScaling: limit }, props.helperText)));
};
export default Switch;
//# sourceMappingURL=Switch.js.map